const state = {
  modal: {
    title: "",
    content: "",
  }
};

const getters = {

  getTitle(state) {
    return state.modal['title']
  },

  getBody(state) {
    return state.modal['content']
  },

};

const mutations = {

  setModal(state, message) {
    if (typeof message !== "object" || 'content' in message === false) {
      return;
    }
    state.modal.content = message.content;
    state.modal.title = message.title || '';
  },

  emptyModal(state) {
    state.modal.title = "";
    state.modal.content = "";
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js